import Vue from 'vue'
import axios from 'axios'
import services from '@/config/services'

const state = {
  user: {
    name: '',
    roles: []
  },
  alerts: false
}

const mutations = {
  setUser (state, { usr_nm, roles }) {
    state.user.name = usr_nm
    state.user.roles = roles
  },
  setAlerts (state, data) {
    state.alerts = data
  },
  unsetData (state) {
    state.user = {
      name: '',
      roles: []
    }
    state.alerts = false
  }
}

const actions = {
  newUser ({ commit }, data) {
    commit('setUser', data)
  },
  newAlerts ({ commit }, data) {
    commit('setAlerts', data)
  },
  clearData ({ commit }) {
    commit('unsetData')
  }
}

const getters = {
  alerts: (state) => state.alerts,
  user: (state) => state.user
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
